// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"b7976e45","239":"1d927617","453":"915c227a","455":"adfcc48c"}[chunkId] + ".chunk.js";
};